import React from 'react';
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const navigate = useNavigate();

  const handleAuthEvent = ({ type }) => {
    if (type === 'signIn') {
      navigate('/admin'); // Navigate to /admin after sign-in
    }
  };

  return (
    <div className="mt-20 mb-20">
      <Authenticator onAuthEvent={handleAuthEvent} hideSignUp>
        {({ user }) => (
          <div className="text-center">
            <p className="text-gray-600">
              Hello, {user ? user.username : "Guest"}!
            </p>
            {user && (
              <button
                onClick={() => navigate('/admin')}
                className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Admin Settings
              </button>
            )}
          </div>
        )}
      </Authenticator>
    </div>
  );
};

export default LoginPage;